exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".myShelfPage{position:relative}.myShelfPage .toggleOptionContainer{width:100%}.myShelfPage .toggleOptionContainer .smallObject .dropdown-toggle{color:#555;font-size:14px}.myShelfPage .displayToggleControl.topToggle{position:relative;text-align:center;z-index:2}.myShelfPage.withToggle .displayToggleControl.topToggle{text-align:center;margin-bottom:0}.myShelfPage.withToggle .bookGrid,.myShelfPage.withToggle .logsWrap{margin-top:47px}.myShelfPage .shelfSpin{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/shelves/my_shelf_page.scss
// module id = 1405
// module chunks = 0